import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconSpellCheckProps } from './IconSpellCheck.types'
import * as Styled from './styles/IconSpellCheck.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSpellCheck: FC<IconSpellCheckProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSpellCheckProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconSpellCheckProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='m21.5 13.031-6.5 6.5-3-3M5.238 8.375c.442-.36 1.266-.613 1.813-.46.547.151 1.074.483 1.074 1.585v3.125'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M7.98 9.84c-.683.035-1.816-.016-2.566.797-.586.636-.492 2.133.95 2.133.874 0 1.616-.883 1.616-.883m2.372-6.192v6.766c.976.488 2.101.422 2.789-.14.765-.626.765-1.348.765-2.137 0-1.418-.82-2.125-1.465-2.25-1.441-.286-2.09.503-2.09.503m5.301 1.883c0-1.906.883-2.433 1.86-2.433.972 0 1.347.691 1.347.691m-3.207 1.742c0 1.907.883 2.438 1.86 2.438.972 0 1.347-.695 1.347-.695'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconSpellCheck
